const updates = [
  {
    date: '08-01',
    tag: '上新',
    tagColor: 'bg-accent-500/15 text-accent-400',
    title: '《流浪地球3》高清版重磅上线',
    desc: '国产科幻巨制第三部，视觉效果全面升级，IMAX画质呈现',
  },
  {
    date: '07-31',
    tag: '热播',
    tagColor: 'bg-primary-500/15 text-primary-500',
    title: '《庆余年3》第12集更新',
    desc: '范闲入京都暗流涌动，权谋大戏渐入高潮',
  },
  {
    date: '07-31',
    tag: '推荐',
    tagColor: 'bg-secondary-500/15 text-secondary-400',
    title: '《哪吒之魔童闹海》独家上线',
    desc: '票房破百亿动画续作，国漫之光高清完整版',
  },
  {
    date: '07-30',
    tag: '上新',
    tagColor: 'bg-accent-500/15 text-accent-400',
    title: '日剧《重启人生》全10集上线',
    desc: '豆瓣9.4分治愈神作，平凡人生中的温暖奇迹',
  },
  {
    date: '07-30',
    tag: '热播',
    tagColor: 'bg-primary-500/15 text-primary-500',
    title: '《乘风破浪的姐姐》第8期更新',
    desc: '全新公演舞台惊艳亮相，姐姐们火力全开',
  },
  {
    date: '07-29',
    tag: '推荐',
    tagColor: 'bg-secondary-500/15 text-secondary-400',
    title: '《奥本海默》导演剪辑版上线',
    desc: '诺兰史诗传记片，IMAX画幅完整呈现核爆震撼',
  },
  {
    date: '07-29',
    tag: '上新',
    tagColor: 'bg-accent-500/15 text-accent-400',
    title: '《鬼灭之刃 无限城篇》更新',
    desc: '最终决战篇开启，炭治郎对抗鬼舞辻无惨',
  },
  {
    date: '07-28',
    tag: '热播',
    tagColor: 'bg-primary-500/15 text-primary-500',
    title: '《奔跑吧》最新季第6期上线',
    desc: '全新嘉宾阵容，欢笑与挑战并存的户外竞技',
  },
  {
    date: '07-28',
    tag: '推荐',
    tagColor: 'bg-secondary-500/15 text-secondary-400',
    title: '《沙丘2》全景声版独家上线',
    desc: '维伦纽瓦科幻史诗，震撼视听沉浸式体验',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            实时同步全网热播，追剧观影快人一步
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300/60 -translate-x-1/2 hidden md:block"></div>

          <div className="space-y-0">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className={`relative flex flex-col md:flex-row items-start gap-4 pb-8 md:pb-10 ${
                  idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 z-10"></div>

                <div className={`flex-1 ${idx % 2 === 0 ? 'md:pr-16 md:text-right' : 'md:pl-16 md:text-left'} pl-8 md:pl-0`}>
                  <div className={`inline-flex items-center gap-2 mb-2 ${idx % 2 === 0 ? 'md:justify-end' : 'md:justify-start'}`}>
                    <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>

                <div className={`flex-1 hidden md:block ${idx % 2 === 0 ? 'md:pl-16' : 'md:pr-16'}`}></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}